import { useTranslation } from 'react-i18next';

import { Icon, Tag } from '~/components';
import { Breadcrumbs } from '~/modules/navigation/components/Breadcrumbs';
import type { LabelDetail } from '~settings/api/lib/schemas';
import { Header } from '~settings/components/Header';
import { SETTINGS_ROUTES } from '~settings/config/routes';

interface EditLabelHeaderProps {
  data: LabelDetail;
  actions?: React.ReactNode;
}

export function EditLabelHeader({ data, actions }: EditLabelHeaderProps) {
  const { t } = useTranslation('settings');
  const { name, parentId } = data;
  const isSublabel = Boolean(parentId);

  return (
    <Header
      breadcrumbs={
        <Breadcrumbs.Root>
          <Breadcrumbs.Item to={SETTINGS_ROUTES.ROOT}>
            <Icon type="gear" size="sm" variant="regular" className="mr-sm" />
            {t('title')}
          </Breadcrumbs.Item>
          <Breadcrumbs.Item to={SETTINGS_ROUTES.LABEL_LIST}>
            {t('labels')}
          </Breadcrumbs.Item>
          <Breadcrumbs.Item>{t('label.editLabel')}</Breadcrumbs.Item>
        </Breadcrumbs.Root>
      }
      className="pb-lg"
    >
      <div className="flex w-full items-center justify-between gap-md">
        <div className="flex items-center gap-md text-strong-on-dark">
          <h1 className="break-all text-display-sm">{name}</h1>
          {isSublabel ? (
            <Tag variant="secondary" size="sm">
              {t('sublabel')}
            </Tag>
          ) : (
            <Tag variant="primary" size="sm">
              {t('parentLabel')}
            </Tag>
          )}
        </div>
        {actions}
      </div>
    </Header>
  );
}
EditLabelHeader.displayName = 'EditLabelHeader';
